import { ShieldCheck, Radio, AlertTriangle, Link2 } from "lucide-react";
import { REFRESH_INTERVAL_MS } from "../hooks/useDashboardData";
import { NotificationSettings } from "../components/NotificationSettings";
import { EaPromptCard } from "../components/EaPromptCard";

const API_BASE_URL = import.meta.env.VITE_API_URL ?? "http://localhost:8787";

const settingsGroups = [
  {
    title: "Data refresh",
    icon: Radio,
    items: [
      {
        label: "Dashboard auto-refresh interval",
        value: `${REFRESH_INTERVAL_MS / 1000} seconds`,
      },
      { label: "EA offline threshold", value: "3 minutes without a heartbeat" },
    ],
  },
  {
    title: "Alert thresholds",
    icon: AlertTriangle,
    items: [{ label: "Drawdown warning", value: "Margin level below 150%" }],
  },
  {
    title: "API endpoint",
    icon: Link2,
    items: [
      { label: "Base URL", value: API_BASE_URL },
      { label: "EA ingestion auth", value: "X-Api-Key header (set via wrangler secret)" },
    ],
  },
  {
    title: "Access",
    icon: ShieldCheck,
    items: [{ label: "Mode", value: "Read-only monitoring - no remote control of EAs" }],
  },
];

export function Settings() {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-500">
        This dashboard only receives and displays data reported by your EAs. These operational
        parameters are configured on the Worker via environment variables and secrets.
      </p>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {settingsGroups.map((group) => (
          <div key={group.title} className="rounded-xl border border-slate-800 bg-slate-900/60 p-5">
            <div className="mb-4 flex items-center gap-2">
              <group.icon className="h-4 w-4 text-emerald-400" />
              <h3 className="text-sm font-semibold text-slate-100">{group.title}</h3>
            </div>
            <dl className="space-y-3">
              {group.items.map((item) => (
                <div key={item.label} className="flex items-start justify-between gap-4 text-sm">
                  <dt className="text-slate-500">{item.label}</dt>
                  <dd className="text-right font-medium text-slate-200">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>

      <NotificationSettings />

      <EaPromptCard apiBaseUrl={API_BASE_URL} />
    </div>
  );
}
